import Vue from 'vue';

const divers = {
    state: {

        reloadModules: [],
        reloadTables: [],
        reloadForms: {},
        activeTab: {},
        pendingActiveTabs: null,
        lastStored: {},
        stringSearch: '',
        picture: {},
        gedFile: [],
        frontDatas: {},
        frontDatasPages: {},
        ventilation: [],
        moduleDatas: [],
        tokenUser : '',

    },

    getters: {

        allDiversStates: (state) => {
            return state
        },

        reloadModules: (state) => {
            return state.reloadModules
        },

        getLastStored: (state) => {
        return state.lastStored
        },

        reloadTables: (state) => {
            return state.reloadTables
        },

        filterListOptions: (state) => (page) => {
            return state.filterListOptions.find(el => el.page === page)
        },

        activeTab: (state) => {
            return state.activeTab
        },
        pendingActiveTabs: (state) => state.pendingActiveTabs,
        getStringSearch: (state) => {
            return state.stringSearch
        },
        getPicture: (state) => {
            return state.picture
        },
        getGedFile: (state) => {
            return state.gedFile
        },
        getFrontDatas: (state) => {
            return state.frontDatas
        },
        getFrontDatasForPage: (state, getters, rootState, rootGetters) => page => {
            const context = rootGetters.specificPage(page)
            return context && context.embedded ? state.frontDatasPages[page] || {} : state.frontDatas
        },
        getVentilation: (state) => {
            return state.ventilation
        },
        getModuleDatas: (state) => (params) => {
            return state.moduleDatas.find(el => el.page === params.page)?.modules.find(mod => mod.id === params.id)
        },
        getReloadForms: (state) => (key) => {
            return state.reloadForms[key]
        },
        getToken: (state) => {
            return state.tokenUser
        },
    },

    mutations: {

        loadToken: function(state, string) {
            state.tokenUser = string;
        },

        changeStringSearch: function(state, string) {
            state.stringSearch = string;
        },

        setActivTab: function(state, elem) {
            var ee = {}
            ee[elem.hook] = elem.tab
            state.activeTab = {...state.activeTab, ...ee }
        },

        replacePendingActiveTabs: function(state, batch) {
            const requests = Array.isArray(batch?.requests) ? batch.requests
                .filter(request => request && Number.isInteger(Number(request.moduleid)) && Number(request.moduleid) > 0
                    && Number.isInteger(Number(request.tabid)) && Number(request.tabid) > 0)
                .map(request => ({
                    moduleid: Number(request.moduleid),
                    tabid: Number(request.tabid),
                    params: request.params && typeof request.params === 'object' && !Array.isArray(request.params)
                        ? { ...request.params } : {},
                })) : [];
            const byModule = new Map(requests.map(request => [request.moduleid, request]));
            state.pendingActiveTabs = typeof batch?.token === 'string' && batch.token && requests.length
                ? { token: batch.token, targetPath: batch.targetPath || '', requests: Array.from(byModule.values()) } : null;
        },

        reconcilePendingActiveTabsNavigation: function(state, { token } = {}) {
            if (state.pendingActiveTabs && state.pendingActiveTabs.token !== token) state.pendingActiveTabs = null;
        },

        consumePendingActiveTabsForModule: function(state, { token, moduleid } = {}) {
            const batch = state.pendingActiveTabs;
            if (!batch || batch.token !== token) return;
            // Les demandes des modules enfants restent disponibles jusqu'à leur chargement.
            const requests = batch.requests.filter(request => request.moduleid !== Number(moduleid));
            state.pendingActiveTabs = requests.length ? { ...batch, requests } : null;
        },

        addReloadModule: function(state, elem) {
            if (Array.isArray(elem.modules)) {
                state.reloadModules = [...state.reloadModules, ...elem.modules]
            } else {
                state.reloadModules.push(elem.modules)
            }

        },

        removeReloadModule: function(state, elem) {
            state.reloadModules = state.reloadModules.filter(data => data != elem);
        },

        addReloadTables: function(state, elem) {
            if (Array.isArray(elem.modules)) {
                state.reloadTables = [...state.reloadTables, ...elem.modules]
            } else {
                state.reloadTables.push(elem.modules)
            }

        },

        removeReloadTables: function(state, elem) {
            state.reloadTables = state.reloadTables.filter(data => data != elem);
        },

        setLastStored: function(state, array) {
            state.lastStored = array
        },

        removeLastStored: function(state) {
            state.lastStored = {}
        },

        setPicture: function(state, pic) {

            state.picture = pic
        },
        removePicture: function(state) {

            state.picture = {}
        },
        putGedFile: function(state, file) {

            state.gedFile.push(file)
        },
        removeGedFile: function(state, file) {

            state.gedFile = state.gedFile.filter(el => el.path != file.path)
        },
        removeAllGedFile: function(state) {

            state.gedFile = []
        },
        setFrontDatas: function(state, datas) {
            if(datas.page) {
                const local = state.frontDatasPages[datas.page] || {}
                Vue.set(state.frontDatasPages, datas.page, { ...local, [datas.module]: datas.datas })
                return
            }
            Vue.delete(state.frontDatas, datas.module);
            Vue.set(state.frontDatas, datas.module, datas.datas);

        },

        addVentilation: function(state, datas) {
            state.ventilation.push(datas)
        },

        removeVentilation: function(state, datas) {
            state.ventilation = state.ventilation.filter(el => el.id != datas.id)
        },

        insertModuleDatas: function(state, datas) {

            state.moduleDatas = state.moduleDatas.filter(el => el.page != datas.page);
            let newModules = { page: datas.page, modules: datas.modules };
            state.moduleDatas.push(newModules);

        },

        removeModuleDatas: function(state, datas) {
            let mod = state.moduleDatas.find(el => el.page == datas.page).modules;
            state.moduleDatas.find(el => el.page == datas.page).modules = mod.filter(el => el.id != datas.id)
        },
        removeModulePageDatas: function(state, page) {
            state.moduleDatas = state.moduleDatas.filter(item => item.page !== page)
            Vue.delete(state.frontDatasPages, page)
            Object.keys(state.activeTab).filter(key => key.startsWith(`${page}:`)).forEach(key => Vue.delete(state.activeTab, key))
        },

        setReloadForms : function(state, datas) {
            state.reloadForms = {
            ...state.reloadForms,
            [datas.modalKey]: datas.fields
            }
        },
        removeReloadForms : function(state,datas) {
            delete state.reloadForms[datas.modalKey];
        },
    },

    actions: {

        addReloadModule: function({ commit }, module) {
            commit('addReloadModule', module)
        },
        removeReloadModule: function({ commit }, module) {
            commit('removeReloadModule', module)
        },

        addReloadTables: function({ commit }, module) {
            commit('addReloadTables', module)
        },
        removeReloadTables: function({ commit }, module) {
            commit('removeReloadTables', module)
        },

        setLastStored: function({ commit }, array) {
            commit('setLastStored', array)
        },

        removeLastStored: function({ commit }) {
            commit('removeLastStored')
        },

        setActivTab: function({ commit }, tab) {
            commit('setActivTab', tab)
        },
        replacePendingActiveTabs: function({ commit }, batch) {
            commit('replacePendingActiveTabs', batch)
        },
        reconcilePendingActiveTabsNavigation: function({ commit }, navigation) {
            commit('reconcilePendingActiveTabsNavigation', navigation)
        },
        consumePendingActiveTabsForModule: function({ commit }, request) {
            commit('consumePendingActiveTabsForModule', request)
        },
        changeStringSearch: function({ commit }, string) {
            commit('changeStringSearch', string)
        },
        setPicture: function({ commit }, pic) {
            commit('setPicture', pic)
        },

        removePicture: function({ commit }) {
            commit('removePicture')
        },

        putGedFile: function({ commit }, file) {
            commit('putGedFile', file)
        },

        removeGedFile: function({ commit }, file) {
            commit('removeGedFile', file)
        },

        removeAllGedFile: function({ commit }) {
            commit('removeAllGedFile')
        },
        setFrontDatas: function({ commit }, datas) {
            commit('setFrontDatas', datas)
        },
        addVentilation: function({ commit }, datas) {
            commit('addVentilation', datas)
        },
        removeVentilation: function({ commit }, datas) {
            commit('removeVentilation', datas)
        },

        insertModuleDatas: function({ commit }, datas) {
            commit('insertModuleDatas', datas)
        },
        removeModuleDatas: function({ commit }, datas) {
            commit('removeModuleDatas', datas)
        },
        removeModulePageDatas: function({ commit }, page) {
            commit('removeModulePageDatas', page)
        },
        setReloadForms: function({ commit }, datas) {
            commit('setReloadForms', datas)
        },
        removeReloadForms: function({ commit }, datas) {
            commit('removeReloadForms', datas)
        },

        loadToken: function({ commit }, datas) {
            commit('loadToken', datas)
        },
    }

}
export default divers;
